<template>
  <div class="main pa-3">
    <div class="pa-5 ma-1 mb-5 pt-10 page-card">
      <v-row>
        <v-col class="ml-0">
          <span class="display-1 font-weight-black ml-5">REPORT</span>
        </v-col>
      </v-row>
      <!-- TIME AND COURSE -->
      <v-row class="align-center justify-center">
        <v-col :lg="4" :md="4" :sm="8" cols="12">
          <div class="datetime d-flex align-center justify-between">
            <span v-if="startDateTime.length>0" class="title font-weight-light ml-3">Start:</span>
            <datetime
              type="datetime"
              input-id="startDate"
              v-model="startDateTime"
              format="dd/MM/yyyy HH:mm:ss"
              placeholder="Start DATE | TIME"
              class="title font-weight-light ml-3"
            ></datetime>
          </div>
        </v-col>
        <v-col :lg="4" :md="4" :sm="8" cols="12">
          <div class="datetime d-flex align-center justify-between">
            <span v-if="endDateTime.length>0" class="title font-weight-light ml-3">End:</span>
            <datetime
              type="datetime"
              input-id="endDate"
              v-model="endDateTime"
              format="dd/MM/yyyy HH:mm:ss"
              placeholder="End DATE | TIME"
              class="title font-weight-light ml-3"
            ></datetime>
          </div>
        </v-col>
        <v-col :lg="4" :md="4" :sm="8" cols="12">
          <v-select
            class="selectCourse mb-0 title font-weight-light"
            v-model="selectedCourse"
            :items="courses"
            rounded
            item-text="title"
            hide-details
            placeholder="Please select COURSE"
            @change="onCourseChange"
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="justify-center align-center">
        <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
          <div class="stat-num stat-num-top px-1">
            <v-col class="d-flex py-0">
              <v-icon class="mr-1 white--text" large>account_circle</v-icon>
              <v-col>
                <v-col class="pa-0">TOTAL STUDENTS</v-col>
                <v-col class="pa-0">(ผู้เรียนทั้งหมด)</v-col>
              </v-col>
            </v-col>
            <v-row class="d-flex align-end mx-1 font-weight-light">
              <v-col>
                <v-icon class="white--text mr-1">trending_up</v-icon>30%
              </v-col>
              <v-col class="text-end pt-0 font-weight-light headline">1000 users</v-col>
            </v-row>
          </div>
        </v-col>
        <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
          <div class="stat-num stat-num-top px-1">
            <v-col class="d-flex py-0">
              <v-icon class="mr-1 white--text" large>assignment_ind</v-icon>
              <v-col>
                <v-col class="pa-0">NEW STUDENTS</v-col>
                <v-col class="pa-0">(ผู้เรียนใหม่)</v-col>
              </v-col>
            </v-col>
            <v-row class="d-flex align-end mx-1 font-weight-light">
              <v-col>
                <v-icon class="white--text mr-1">trending_up</v-icon>30%
              </v-col>
              <v-col class="text-end pt-0 font-weight-light headline">1000 users</v-col>
            </v-row>
          </div>
        </v-col>
        <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
          <div class="stat-num stat-num-corner px-1">
            <v-col class="d-flex py-0">
              <v-icon class="mr-1 white--text" large>toggle_on</v-icon>
              <v-col>
                <v-col class="pa-0">ONLINE</v-col>
                <v-col class="pa-0">(กำลังออนไลน์)</v-col>
              </v-col>
            </v-col>
            <v-row class="d-flex align-end mx-1 font-weight-light">
              <v-col>
                <v-icon class="white--text mr-1">trending_up</v-icon>30%
              </v-col>
              <v-col class="text-end pt-0 font-weight-light headline">1000 users</v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>

      <!-- OVERALL GRAPH -->
      <v-row class="align-center justify-center">
        <v-col :lg="8" :md="8" :sm="12" cols="12" class="pa-3">
          <div class="graph-card pa-5 pt-3">
            <v-col>
              <v-col class="pr-2 d-flex justify-between align-end">
                <span class="headline font-weight-light">{{selectedCourse}}</span>
              </v-col>
              <apexchart
                type="area"
                height="320"
                :options="overallChartOptions"
                :series="overallSeries"
              ></apexchart>
            </v-col>
          </div>
        </v-col>

        <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-0">
          <v-col class="pa-3">
            <div class="stat-num stat-num-right px-2">
              <v-col class="d-flex py-0">
                <v-icon class="mr-1 white--text" large>visibility</v-icon>
                <v-col>
                  <v-col class="pa-0">TOTAL VIEWS</v-col>
                  <v-col class="pa-0">(ยอดวิวสะสมตามช่วงเวลาที่กำหนด)</v-col>
                </v-col>
              </v-col>
              <v-row class="d-flex align-end mx-1 font-weight-light">
                <v-col>
                  <v-icon class="white--text mr-1">trending_up</v-icon>30%
                </v-col>
                <v-col class="text-end font-weight-light pt-0 headline">1,000,000 views</v-col>
              </v-row>
            </div>
          </v-col>
          <v-col class="pa-3">
            <div class="stat-num stat-num-right px-2">
              <v-col class="d-flex py-0">
                <v-icon class="mr-1 white--text" large>laptop_chromebook</v-icon>
                <v-col>
                  <v-col class="pa-0">NUMBER OF STUDENTS (จำนวนผู้เข้าเรียนตามช่วงเวลาที่กำหนด)</v-col>
                </v-col>
              </v-col>
              <v-row class="d-flex align-end mx-1 font-weight-light">
                <v-col>
                  <v-icon class="white--text mr-1">trending_up</v-icon>30%
                </v-col>
                <v-col class="text-end font-weight-light pt-0 headline">1000 users</v-col>
              </v-row>
            </div>
          </v-col>
          <v-col class="pa-3">
            <div class="stat-num stat-num-right px-2">
              <v-col class="d-flex py-0">
                <v-icon class="mr-1 white--text" large>verified_user</v-icon>
                <v-col>
                  <v-col class="pa-0">AVERAGE COMPLETED</v-col>
                  <v-col class="pa-0">(ความสำเร็จเฉลี่ย)</v-col>
                </v-col>
              </v-col>
              <v-col class="text-end pt-0">
                <span class="font-weight-light headline">{{ Math.ceil(avgCompleted) }}%</span>
                <div class="progress-bar pa-2 px-3 mb-3 mt-3">
                  <v-progress-linear
                    :value="avgCompleted"
                    rounded
                    striped
                    height="10"
                    color="rgba(25, 118, 210, 0.8)"
                  ></v-progress-linear>
                </div>
              </v-col>
            </div>
          </v-col>
        </v-col>
      </v-row>

      <!-- INDIVIDUAL GRAPH -->
      <v-row class="align-center justify-center">
        <v-col :lg="8" :md="8" :sm="12" cols="12" class="pa-3">
          <v-col class="graph-card pa-3">
            <v-col class="pr-2">
              <span class="headline font-weight-light">Attendence</span>
            </v-col>
            <apexchart
              type="area"
              height="270"
              :options="attendenceChartOptions"
              :series="attendenceSeries"
            ></apexchart>
          </v-col>
        </v-col>
        <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
          <div class="graph-card pa-3 pl-0 pr-0">
            <v-col class="text-right pr-6 py-0">
              <span class="headline font-weight-light">Attendence</span>
            </v-col>
            <v-col class="text-right pr-6 mt-0 pt-0 pb-3">
              <span class="font-weight-light">การเข้าเรียน</span>
            </v-col>

            <v-col class="text-end pb-0 pr-6 font-weight-light display-2">30 mins</v-col>
            <v-col class="text-end py-0 pr-6">Average Learning Time</v-col>

            <v-col class="text-end pb-0 pr-6 font-weight-light display-2">
              <span class="headline font-weight-light">(09:30-10:30)</span>100
            </v-col>
            <v-col class="text-end py-0 pr-6">Highest Students Number</v-col>

            <v-col class="text-end pb-0 pr-6 font-weight-light display-2">
              <span class="headline font-weight-light">(13:30-14:30)</span>10
            </v-col>
            <v-col class="text-end py-0 pr-6 mb-4">Lowest Students Number</v-col>
          </div>
        </v-col>
      </v-row>
      <v-row class="align-center justify-center">
        <v-col :lg="8" :md="8" :sm="12" cols="12" class="pa-3">
          <div class="graph-card pa-3">
            <v-col class="pr-2">
              <span class="headline font-weight-light">Examination</span>
            </v-col>
            <apexchart type="area" height="270" :options="examChartOptions" :series="examSeries"></apexchart>
          </div>
        </v-col>
        <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
          <div class="graph-card pa-3 pr-0 pl-0">
            <v-col class="text-right pr-6 py-0">
              <span class="headline font-weight-light">Exam's Average Score</span>
            </v-col>
            <v-col class="text-right pr-6 mt-0 pt-0">
              <span class="font-weight-light">คะแนนเฉลี่ยการสอบแต่ละครั้ง</span>
            </v-col>
            <v-col id="chart" class="px-5 pb-0 pt-0">
              <apexchart
                type="bar"
                height="260"
                :options="examAvgChartOptions"
                :series="examAvgSeries"
              ></apexchart>
            </v-col>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import VueApexCharts from "vue-apexcharts";
import { getCourse } from "@/service/course/course";

export default {
  components: {
    datetime: Datetime,
    apexchart: VueApexCharts,
  },

  data() {
    return {
      slug: "",
      data: [],

      startDateTime: "",
      endDateTime: "",

      avgCompleted: 80,

      courses: ["All Courses", "English", "Math", "Physics"],
      selectedCourse: "All Courses",

      overallSeries: [
        {
          name: "Num of Students",
          data: [
            [1351724400000, 34.36],
            [1351810800000, 34.39],
            [1352070000000, 34.24],
            [1352156400000, 34.39],
            [1352242800000, 33.47],
            [1352329200000, 32.98],
            [1352415600000, 32.9],
            [1352674800000, 32.7],
            [1352761200000, 32.54],
            [1352847600000, 32.23],
            [1352934000000, 32.64],
            [1353020400000, 32.65],
            [1353279600000, 32.92],
            [1353366000000, 32.64],
            [1353452400000, 32.84],
            [1353625200000, 33.4],
            [1353884400000, 33.3],
            [1353970800000, 33.18],
            [1354057200000, 33.88],
            [1354143600000, 34.09],
            [1354230000000, 34.61],
            [1354489200000, 34.7],
            [1354575600000, 35.3],
            [1354662000000, 35.4],
            [1354748400000, 35.14],
            [1354834800000, 35.48],
            [1355094000000, 35.75],
            [1355180400000, 35.54],
            [1355266800000, 35.96],
            [1355353200000, 35.53],
            [1355439600000, 37.56],
            [1355698800000, 37.42],
            [1355785200000, 37.49],
            [1355871600000, 38.09],
            [1355958000000, 37.87],
            [1356044400000, 37.71],
            [1356303600000, 37.53],
            [1356476400000, 37.55],
            [1356562800000, 37.3],
            [1356649200000, 36.9],
            [1356908400000, 37.68],
            [1357081200000, 38.34],
            [1357167600000, 37.75],
            [1357254000000, 38.13],
            [1357513200000, 37.94],
            [1357599600000, 38.14],
            [1357686000000, 38.66],
            [1357772400000, 38.62],
            [1357858800000, 38.09],
            [1358118000000, 38.16],
            [1358204400000, 38.15],
            [1358290800000, 37.88],
            [1358377200000, 37.73],
            [1358463600000, 37.98],
            [1358809200000, 37.95],
            [1358895600000, 38.25],
            [1358982000000, 38.1],
            [1359068400000, 38.32],
            [1359327600000, 38.24],
            [1359414000000, 38.52],
            [1359500400000, 37.94],
            [1359586800000, 37.83],
            [1359673200000, 38.34],
            [1359932400000, 38.1],
            [1360018800000, 38.51],
            [1360105200000, 38.4],
            [1360191600000, 38.07],
            [1360278000000, 39.12],
            [1360537200000, 38.64],
            [1360623600000, 38.89],
            [1360710000000, 38.81],
            [1360796400000, 38.61],
            [1360882800000, 38.63],
            [1361228400000, 38.99],
            [1361314800000, 38.77],
            [1361401200000, 38.34],
            [1361487600000, 38.55],
            [1361746800000, 38.11],
            [1361833200000, 38.59],
            [1361919600000, 39.6],
          ],
        },
      ],
      overallChartOptions: {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        title: {
          text: "",
          align: "left",
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0.5,
            stops: [0, 90, 100],
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val;
            },
          },
          title: {
            text: "Num of Students",
          },
        },
        xaxis: {
          type: "datetime",
        },
        tooltip: {
          x: {
            format: "dd/MM/yy",
          },
        },
      },

      attendenceSeries: [
        {
          name: "Num of Students",
          data: [
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
          ],
        },
      ],
      attendenceChartOptions: {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        title: {
          text: "",
          align: "left",
        },
        colors: ["#61dafb"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0.5,
            stops: [0, 90, 100],
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val;
            },
          },
          title: {
            text: "Num of Students",
          },
        },
        xaxis: {
          type: "datetime",
          categories: [
            "2018-09-19T00:00:00.000Z",
            "2018-09-19T01:00:00.000Z",
            "2018-09-19T02:00:00.000Z",
            "2018-09-19T03:00:00.000Z",
            "2018-09-19T04:00:00.000Z",
            "2018-09-19T05:00:00.000Z",
            "2018-09-19T06:00:00.000Z",
            "2018-09-19T07:00:00.000Z",
            "2018-09-19T08:00:00.000Z",
            "2018-09-19T09:00:00.000Z",
            "2018-09-19T10:00:00.000Z",
            "2018-09-19T11:00:00.000Z",
            "2018-09-19T12:00:00.000Z",
            "2018-09-19T13:00:00.000Z",
            "2018-09-19T14:00:00.000Z",
            "2018-09-19T15:00:00.000Z",
            "2018-09-19T16:00:00.000Z",
            "2018-09-19T17:00:00.000Z",
            "2018-09-19T18:00:00.000Z",
            "2018-09-19T19:00:00.000Z",
            "2018-09-19T20:00:00.000Z",
            "2018-09-19T21:00:00.000Z",
            "2018-09-19T22:00:00.000Z",
            "2018-09-19T23:00:00.000Z",
          ],
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      },

      examSeries: [
        {
          name: "Num of Students",
          data: [
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
          ],
        },
      ],
      examChartOptions: {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        title: {
          text: "",
          align: "left",
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100],
          },
        },
        colors: ["#ffd31d"],
        yaxis: {
          labels: {
            formatter: function (val) {
              return val;
            },
          },
          title: {
            text: "Num of Students",
          },
        },
        xaxis: {
          type: "datetime",
          categories: [
            "2018-09-19T00:00:00.000Z",
            "2018-09-19T01:00:00.000Z",
            "2018-09-19T02:00:00.000Z",
            "2018-09-19T03:00:00.000Z",
            "2018-09-19T04:00:00.000Z",
            "2018-09-19T05:00:00.000Z",
            "2018-09-19T06:00:00.000Z",
            "2018-09-19T07:00:00.000Z",
            "2018-09-19T08:00:00.000Z",
            "2018-09-19T09:00:00.000Z",
            "2018-09-19T10:00:00.000Z",
            "2018-09-19T11:00:00.000Z",
            "2018-09-19T12:00:00.000Z",
            "2018-09-19T13:00:00.000Z",
            "2018-09-19T14:00:00.000Z",
            "2018-09-19T15:00:00.000Z",
            "2018-09-19T16:00:00.000Z",
            "2018-09-19T17:00:00.000Z",
            "2018-09-19T18:00:00.000Z",
            "2018-09-19T19:00:00.000Z",
            "2018-09-19T20:00:00.000Z",
            "2018-09-19T21:00:00.000Z",
            "2018-09-19T22:00:00.000Z",
            "2018-09-19T23:00:00.000Z",
          ],
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      },

      examAvgSeries: [
        {
          name: "Average Score",
          // data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
          data: [44, 55, 57, 76, 90],
        },
        // {
        //   name: "Revenue",
        //   data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
        // },
        // {
        //   name: "Free Cash Flow",
        //   data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
        // }
      ],
      examAvgChartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "30%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#ffd31d"],
        stroke: {
          show: false,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["1st", "2nd", "3rd", "4th", "5th"],
          title: {
            text: "No. of Examination",
          },
        },
        yaxis: {
          title: {
            text: "Average Score (%)",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " %";
            },
          },
          x: {
            formatter: function (val) {
              return val + " examination";
            },
          },
        },
      },
      params: {
        searchCourse: null,
        searchStudent: null,
        sort: "created_at",
        sortby: -1,
        page: 1,
        limit: 10,
        active: null,
        category: [],
        skill: [],
      },
    };
  },
  methods: {
    async getCourseList() {
      let result = await getCourse(this.params);
      this.courses = result.data;
      console.log(this.courses);
    },
  },
  async mounted() {
    await this.getCourseList();
  },
};
</script>

<style lang="scss">
.main {
  background-color: rgb(241, 243, 245);
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background: white;
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.datetime {
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.datetime:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.selectCourse {
  height: auto;
  border: 0px;
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.selectCourse:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.progress-bar {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.9);
}

.stat-num {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.stat-num-top {
  background-image: linear-gradient(rgba(#0779e4, 0.7), rgba(#0779e4, 0.4));
  color: white;
}

.stat-num-corner {
  background-image: linear-gradient(rgba(#4cbbb9, 0.8), rgba(#4cbbb9, 0.5));
  color: white;
}

.stat-num-right {
  background-image: linear-gradient(rgba(#084177, 0.5), rgba(#084177, 0.3));
  color: white;
}

.stat-num:hover {
  // box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
  // background-color: rgba(#0779e4, 0.4);
  transform: scale(1.05, 1.05);
}

.graph-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  // box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
  transform: scale(1.02, 1.02);
}
</style>